
  export default {
    name: 'ThemeStoresMobileIosPrivacy',
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      dataLinkedToYou() {
        return [
          { icon: 'mdi-briefcase', label: 'purchases' },
          { icon: 'mdi-credit-card-chip-outline', label: 'financialInfo' },
          { icon: 'mdi-map-marker', label: 'location' },
          { icon: 'mdi-information', label: 'contactInfo' },
          { icon: 'mdi-cog-outline', label: 'diagnostics' },
          { icon: 'mdi-poll', label: 'usageData' }
        ]
      },
      dataNotLinkedToYou() {
        return [
          { icon: 'mdi-magnify', label: 'searchHistory' },
          { icon: 'mdi-card-account-details', label: 'identifiers' },
          { icon: 'mdi-image-multiple-outline', label: 'userContent' },
          { icon: 'mdi-account-circle-outline', label: 'contacts' }
        ]
      },
      information() {
        return [
          {
            title: this.tl('provider'),
            value: this.pwa?.pwa_app_settings?.company_name
          },
          {
            title: this.tl('ageRating'),
            value: `${this.pwa?.pwa_app_settings?.user_age}+`
          },
          {
            title: this.tl('copyRight'),
            value: `© ${new Date().getFullYear()} ${this.pwa?.pwa_app_settings?.company_name}`
          },
          {
            title: this.tl('developerWebsite'),
            value: null,
            icon: 'mdi-apple-safari'
          },
          {
            title: this.tl('privacyPolicy'),
            value: null,
            icon: 'mdi-hand-back-left'
          }
        ]
      }
    }
  }
